import React from "react";
import { NavigateFunction } from "react-router-dom";
import { ProjectCardInter } from "../../interface/interface";
import { formatDate } from "../../lib/lib";

type Props = {
  index: number;
  data: ProjectCardInter;
  navigate: NavigateFunction;
};

const FinishCard = ({ index, data, navigate }: Props) => {
  const {
    mtup_typ,
    prjt_nm,
    rcrt_apply_en_at,
    leadr_usr_nm,
    tot_rcrt_cnt,
    usr_rcrt_cnt,
    prjt_type_cd,
  } = data;

  return (
    <div className="finish-card-comp">
      <div className="finish-category">
        {mtup_typ === "OFFLINE" ? "대면" : "비대면"}
      </div>
      <div className="finish-title">{prjt_nm}</div>
      <div className="finish-time">{formatDate(rcrt_apply_en_at, "-")}</div>
      <div className="finish-leader">{leadr_usr_nm}</div>
      <div className="finish-num">
        {usr_rcrt_cnt}/{tot_rcrt_cnt}
      </div>
      <button
        className="detail-btn"
        onClick={() => {
          navigate(`/${prjt_type_cd}/list`, {
            state: data,
          });
        }}
      >
        상세보기
      </button>
    </div>
  );
};

export default FinishCard;
